<template>
  <div
    class="modal has-overflow"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">

      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">
            Add an Item to Estimate
          </p>
          <button
            class="delete"
            aria-label="close"
            @click="close()">
          </button>
        </header>

        <v-form class="modal-card-body" :valid.sync="valid">

          <!-- <div class="field">
            <label class="label">Item Name*</label>
            <v-text-field
              required
              placeholder="Item Name"
              v-model="item.item_name"/>
          </div> -->

          <div class="field">
            <label class="label">Item Architectural Name*</label>
            <v-text-field
              required
              placeholder="Item Architectural Name"
              v-model="item.architecture_name"/>
          </div>

        </v-form>
        
        <footer class="modal-card-foot">
          <button 
            :disabled="!item.architecture_name || !valid"
            class="button is-primary" 
            @click.stop="save()">
            Save
          </button>
          <button 
            class="button" 
            @click.stop="close(true)">
            Cancel
          </button>
        </footer>

      </div>
    </div>
  </div>
</template>

<script>
import VForm from '@/components/base/VForm'
import VTextField from '@/components/base/VTextField'

import { mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean
    },
    rfq: {
      type: Object
    }
  },
  components: { 
    VForm, VTextField
  },
  data() {
    return {
      valid: false,
      item: {
        item_name: null,
        architecture_name: null,
        order: null
      }
    }
  },
  methods: {
    ...mapActions("rfq", ["addItem", "addEstimation"]),
    save() {
      if (this.rfq.c_estimation) {
        this.add(this.rfq.c_estimation.id);
      } else {
        this.addEstimation({
          project_rfq_id: this.rfq.id
        }).then(resp => {
          this.add(resp.data.id);
        })
      }
    },
    add(estimationId) {
      this.item.estimation_id = estimationId;
      this.item.order = this.rfq.c_estimation ? 
        Math.max(...this.rfq.c_estimation.items.map(d => d.order),
        this.rfq.c_estimation.items.length) : 0;
      this.addItem(this.item).then(() => {
        this.close()
      })
    },
    close(clear=false) {
      this.$emit('input', false);
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>